import React from 'react';
import { motion } from 'framer-motion';
import { FaMapMarkerAlt, FaPhone } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <motion.footer 
      className="py-6 mt-6 border-t border-gold/30"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.8, duration: 0.5 }}
    >
      <div className="container mx-auto px-4">
        <div className="flex flex-col items-center">
          <motion.p 
            className="text-sm text-gold text-center font-semibold"
            whileHover={{ 
              scale: 1.05,
              textShadow: "0 0 8px rgba(234, 179, 8, 0.6)",
            }}
          >
            &copy; {currentYear} PorterHouse Carnes. Todos os direitos reservados.
          </motion.p>
          
          <div className="mt-4 flex flex-col md:flex-row items-center justify-center space-y-2 md:space-y-0 md:space-x-6">
            <motion.div 
              className="flex items-center text-gold/80 text-xs"
              whileHover={{ 
                scale: 1.05, 
                color: "#eab308",
                transition: { duration: 0.2 }
              }}
            >
              <FaMapMarkerAlt className="mr-1" />
              <span>R. Londrina, 217 - Sítio Cercado, Curitiba - PR, 81900-390</span>
            </motion.div>
            
            <motion.div 
              className="flex items-center text-gold/80 text-xs"
              whileHover={{ 
                scale: 1.05, 
                color: "#eab308",
                transition: { duration: 0.2 }
              }}
            >
              <FaPhone className="mr-1" />
              <span>(41) 98856-1142</span>
            </motion.div>
          </div>
        </div>
      </div>
    </motion.footer>
  );
};

export default Footer; 